/** @format */

export interface Messaging {
  identifier: string;
  message: string;
}
